import { defineStore } from "pinia";

export const useCnasAgencyStore = defineStore('cnasAgency', {
    state: () => ({
        cnasAgency: {},
        cnasAgencies: [],
    }),
    actions: {
        setCnasAgency(cnasAgency) {
            this.cnasAgency = cnasAgency
        },
        setCnasAgencies(cnasAgencies) {
            this.cnasAgencies = cnasAgencies
        },
        addCnasAgency(cnasAgency) {
            this.cnasAgencies.unshift(cnasAgency)
        },
        updateCnasAgency(cnasAgency) {
            let index = this.cnasAgencies.findIndex(cl => cl.id === cnasAgency.id)
            this.cnasAgencies.splice(index, 1, cnasAgency)
        },
        deleteCnasAgency(cnasAgency) {
            let index = this.cnasAgencies.findIndex(cl => cl.id === cnasAgency.id)
            this.cnasAgencies.splice(index, 1)
        },
    },
});